var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfoBigDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 33,
    viewBox: "0 0 7 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 542"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1270",
    cx: 3.5,
    cy: 16.5,
    rx: 3.5,
    ry: 3.5,
    transform: "rotate(90 3.5 16.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1272",
    cx: 3.5,
    cy: 29.5,
    rx: 3.5,
    ry: 3.5,
    transform: "rotate(90 3.5 29.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1271",
    cx: 3.5,
    cy: 3.5,
    rx: 3.5,
    ry: 3.5,
    transform: "rotate(90 3.5 3.5)",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoBigDot);
export default __webpack_public_path__ + "static/media/iconInfoBigDot.a3afef717594729e5fa5e094f8b55e0f.svg";
export { ForwardRef as ReactComponent };